export const CREATE_WORKSPACE = `
    mutation CreateWorkspace($account_id: Int!, $name: String! $image: String) {
        createWorkspace(account_id: $account_id, name: $name, image: $image) {
            id
            name
            image
            custom_properties {
                key
                value
            }
            archived
            account {
                id
                name
                type
            }
        }
    }
`;

export const UPDATE_WORKSPACE = `
    mutation UpdateWorkspace($workspace_id: Int!, $name: String, $image: String, $archived: Boolean, $remove_image: Boolean) {
        updateWorkspace(workspace_id: $workspace_id, name: $name, image: $image, archived: $archived, remove_image: $remove_image) {
            id
            name
            image
            custom_properties {
                key
                value
            }
            archived
            account {
                id
                name
                type
            }
        }
    }
`;

export const GRANT_INVITE_WORKSPACE_USER_ROLE = `
    mutation GrantUserRole($account_id: Int!, $workspace_ids: [Int], $email: String, $user_id: Int, $role: RoleEnum) {
        grantUserRole(account_id: $account_id, workspace_ids: $workspace_ids, email: $email, user_id: $user_id, role: $role) {
            user {
                id
                first_name
                last_name
                username
                email
                phone
                avatar
            }
            projects {
                applies_to_all
                invited_date
                project {
                    id
                    name
                    due_date
                    creator_count
                    image
                }
                role {
                    id
                    name
                    seniority
                }
            }
            role {
                id
                name
                seniority
            }
        }
    }
`;

export const REVOKE_WORKSPACE_USER_ROLE = `
    mutation RevokeUserRole($workspace_id: Int!, $user_id: Int!, $role: RoleEnum) {
        revokeUserRole(workspace_id: $workspace_id, user_id: $user_id, role: $role) 
    }

`;

export const REVOKE_ALL_WORKSPACE_USER_ROLES = `
    mutation RevokeAllUserRoles($workspace_id: Int!, $user_id: Int!) {
    revokeAllUserRoles(workspace_id: $workspace_id, user_id: $user_id)}
`;

export const DELETE_WORKSPACE = `
    mutation DeleteWorkspace($workspace_id: Int!) {
        deleteWorkspace(workspace_id: $workspace_id) {
            id
            name
        }
    }
`;

export const RESTORE_WORKSPACE = `
    mutation RestoreWorkspace($workspace_id: Int!) {
        restoreWorkspace(workspace_id: $workspace_id) {
            id
            name
        }
    }
`;
